import React from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import AdminServiceProgressionTable from "../../components/ServiceRequests/Admin/AdminServiceProgressionTable";
import Actions from "../../components/ServiceRequests/Admin/Actions";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";

import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import Spinner from "../../common/Spinner/Spinner";
import ConfirmHandholderAssignmentModal from "../../components/ServiceRequests/Handholder/ConfirmHandholderAssignmentModal";
import CustomerFeedbackContainer from "../EServicePartnerServiceRequests/CustomerFeedbackContainer";

const PAGE_SIZE = 10;

export default function AdminServiceRequestsContainer(props) {
	const FileInputref = React.useRef();
	const [isLoading, setIsLoading] = useState(false);
	const [serviceRequests, setServiceRequests] = useState([]);
	const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);

	const [serviceNameList, setServiceNameList] = useState([]);
	const [selectedServiceNameList, setSelectedServiceNameList] = useState([]);

	/**
	 * For Selectiing Facilitators
	 */
	const [facilitatorList, setFacilitatorList] = useState([]);
	const [selectedFacilitator, setSelectedFacilitator] = useState(null);

	const [
		showUnassignedServiceRequests,
		toggleUnassignedServiceRequests,
	] = useState(false);

	const [showFollowupInPast, toggleFollowupInPast] = useState(false);
	const [showToBeFolledUpToday, toggleToBeFolledUpToday] = useState(false);
	const [showFailedPayments, toggleFailedPayments] = useState(false);

	const [searchTerm, setSearchTerm] = useState("");
	const [searchFilter, setSearchFilter] = useState(null);
	const [filterError, setFilterError] = useState(false);

	const [tableInstance, setTableInstance] = useState(null);

	const [serviceRequestStatusList, setServiceRequestStatusList] = useState(
		[]
	);
	const [
		selectedServiceRequestStatusList,
		setSelectedServiceRequestStatusList,
	] = useState([]);
	const [
		selectedServiceRequestsHasFacilitator,
		setSelectedServiceRequestsHasFacilitator,
	] = useState(false);

	const [isAssignFacilitatorUploadOpen, setisAssignFacilitatorUploadOpen] = useState(false);
	const handleAssignFacilitatorUploadClick = () => 
	{
		setisAssignFacilitatorUploadOpen(!isAssignFacilitatorUploadOpen);
	};

	const [
		AssignFacilitatorFile,
		setAssignFacilitatorFile,
	] = useState();

	const onAssignFacilitatorUpload = (e) => {
		console.log("files", e.target.files);
		setAssignFacilitatorFile(e.target.files[0]);
	};

	useEffect(() => {
		if (selectedServiceRequests.length > 0)
			selectedServiceRequests.map((x) => {
				if (x.refFacilitator.length !== 0) {
					setSelectedServiceRequestsHasFacilitator(true);
				}
			});
	}, [selectedServiceRequests]);

	const [SPMStatusList, setSPMStatusList] = useState([
		{
			checked: false,
			label: "Ready for Progression",
			id: "Ready for Progression",
			code: "Ready for Progression",
		},
		{
			checked: false,
			label: "Payment Confirmed By Partner",
			id: "Payment Confirmed By Partner",
			code: "Payment Confirmed By Partner",
		},
		{
			checked: false,
			label: "Awaiting For Information/Documents",
			id: "Awaiting For Information/Documents",
			code: "Awaiting For Information/Documents",
		},	
		{
			checked: false,
			label: "Service Delivery Start",
			id: "Service Delivery Start",
			code: "Service Delivery Start",
		},
		{
			checked: false,
			label: "Service Deliverables Ready",
			id: "Service Deliverables Ready",
			code: "Service Deliverables Ready",
		},
		{
			checked: false,
			label: "Full Payment Requested",
			id: "Full Payment Requested",
			code: "Full Payment Requested",
		},
		{
			checked: false,
			label: "Full Payment Received",
			id: "Full Payment Received",
			code: "Full Payment Received",
		},
		{
			checked: false,
			label: "Delivered",
			id: "Delivered",
			code: "Delivered",
		},
		{
			checked: false,
			label: "Cancelled",
			id: "Cancelled",
			code: "Cancelled",
		},
	]);
	const [selectedSPMStatus, setSelectedSPMStatus] = useState([]);

	const [paymentStatusList, setPaymentStatusList] = useState([
		{ checked: false, label: "Credit", id: "Credit", code: "Credit" },
		{ checked: false, label: "Failed", id: "Failed", code: "Failed" },
	]);
	const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);

	const [currentActiveTab, setCurrentActiveTab] = useState("Service Requests");
	const [unReadFeedbackCount, setunReadFeedbackCount] = useState(0);

	/*Package Filter states*/
	const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
	const [
		servicesThroughPackageOptions,
		setservicesThroughPackageOptions,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedServicesThroughPackageOption,
		setSelectedServicesThroughPackageOption,
	] = useState({
		value: "all",
		label: "All",
	});
	/*Package Filter States end*/

	/**
	 * pagination states
	 */
	const [pages, setPages] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const history = useHistory();
	useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		if (!getUser()) {
			history.push("/login");
		}
		api.getAllFacilitators().then(({ data }) => {
			const f = Object.keys(data).map((e) => ({ value: e, label: e }));
			setFacilitatorList(f);
		});

		api.getAllPackageCatalogues().then(({ data }) => 
		{
			const packageNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sPackageOfferTitle,
					id: data[idx].id,
					value: data[idx].id,
				};
			});
			setPackageNameListForFilter(packageNamesForFilter);
		});

	}, []);
	// useDebouncedEffect(
	// 	() => {
	// 		getAllServiceRequests(tableInstance);
	// 	},
	// 	1000,
	// 	[
	// 		searchTerm,
	// 		selectedSPMStatus,
	// 		selectedPaymentStatus,
	// 		selectedServiceRequestStatusList,
	// 		showUnassignedServiceRequests,
	// 		selectedServiceNameList,
	// 		showFollowupInPast,
	// 		showToBeFolledUpToday,
	// 		showFailedPayments,
	// 		tableInstance,
	// 	]
	// );
	const fetchServiceRequests = (instance, flag) => {
		// setNavigationClicked(flag);
		getAllServiceRequests(instance, flag);
	};

	const [restoreToFirstPage, setRestoreToFirstPage] = useState(undefined);

	const uploadAssignFacilitatorFile = () => {
		if (!AssignFacilitatorFile) 
        {
            toast("Please select file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
		var formData = new FormData();

		formData.append(
			"assign_facilitator_data",
			AssignFacilitatorFile,
			AssignFacilitatorFile.name
		);
		setIsLoading(true);
		const data = api
		.uploadAssignFacilitatorData(formData)
		.then(({ data }) => {
			setIsLoading(false);
			FileInputref.current.value = "";
			setAssignFacilitatorFile(null);
			if(data.message)
			{
				toast(data.message, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			else
			{
				toast("File uploaded successful", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			
		})
		.catch((error) => {
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
		});
	};

	const getAllServiceRequests = async (instance, flag = false) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		try {
			const { page } = instance.state ?? { page: 0 };
			const pageSize = instance.state.pageSize;

			let searchFilterParams = null;
			let sortParams = null;
			if (searchFilter) {
				const { value } = searchFilter;
				searchFilterParams = { [value]: searchTerm };
			}
			if (instance.state.sorted.length > 0) {
				const { id, desc } = instance.state.sorted[0];
				sortParams = { column: id, desc };
			}
			const unassigned = showUnassignedServiceRequests;
			const serviceRequestList = selectedServiceNameList;
			const followupInPast = showFollowupInPast;
			const followupToday = showToBeFolledUpToday;
			const failedPayments = showFailedPayments;
			const statusList = selectedSPMStatus;
			const paymentStatus = selectedPaymentStatus;
			let packageListtemp = [];
			selectedPackageNameListForFilter.map((e) => {
				if(e.value!="*")
				{
					packageListtemp.push(e.value);
				}
			});
			const PackageList=packageListtemp
			const ServicesThroughPackage = selectedServicesThroughPackageOption;
			setIsLoading(true);
			const { data } = await api.getAllServicesSPM(
				page + 1,
				pageSize,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				followupInPast,
				followupToday,
				failedPayments,
				ServicesThroughPackage,
				PackageList,
				searchFilterParams,
				sortParams,
				flag
			);
			getUnreadFeedbackCount();
			setIsLoading(false);
			let { results, count } = data;
			const totalPages = (count - 1) / pageSize + 1;
			results = results.map((e) => {
				if (e["customer_meta"]&&e["customer_meta"]["email"])
					e["sEmailAddress"] = e["customer_meta"]["email"];
				else e["sEmailAddress"] = "";
				if (e["customer_meta"]&&e["customer_meta"]["mobile_number"])
					e["sContactNumber"] = e["customer_meta"]["mobile_number"];
				else e["sContactNumber"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});			
			if (flag === false) setRestoreToFirstPage(0);
			else setRestoreToFirstPage(undefined);
			setServiceRequests(results);
			setPages(Math.floor(totalPages));
			setPageSize(pageSize)
		} catch (error) {
			console.error(error);
		}
	};

	const handleFacilitatorAssigned = () => {
		if (!selectedFacilitator) {
			toast("Please select a facilitator.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (selectedServiceRequests.length === 0) return;
		const serviceRequestsUserIDs = selectedServiceRequests.map(
			(sr) => sr.nUserId
		);
		const facilitator = selectedFacilitator.value;
		const payload = {
			Facilitator: facilitator,
			user_ids: serviceRequestsUserIDs,
		};
		setIsLoading(true);
		api.assignFacilitator(payload)
			.then((response) => {
				setSelectedFacilitator(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};

	const handleFacilitatorUnAssigned = () => {
		if (selectedServiceRequests.length === 0) return;
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		const payload = {
			Facilitator: null,
			nResourceInstanceIds: serviceRequests,
		};
		setIsLoading(true);
		api.assignFacilitator(payload)
			.then((response) => {
				setSelectedFacilitator(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};

	const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) {
			setFilterError(true);
		}
	};
	const handleSearchClick = async () => {
		if (searchTerm.length > 0 && searchFilter) {
			const { value } = searchFilter;
			const { data } = await api.searchServiceRequestsSPM({
				[value]: searchTerm,
			});

			let { results, count } = data;
			const totalPages = (count - 1) / pageSize + 1;

			results = results.map((e) => {
				if (e["customer_meta"]["email"])
					e["sEmailAddress"] = e["customer_meta"]["email"];
				else e["sEmailAddress"] = "";
				if (e["customer_meta"]["mobile_number"])
					e["sContactNumber"] = e["customer_meta"]["mobile_number"];
				else e["sContactNumber"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});
			setServiceRequests(results);

			setPages(Math.floor(totalPages));
		}
		if (searchTerm.length === 0) {
			getAllServiceRequests(tableInstance);
		}
	};
	const handleClearFilterSearch = () => {
		setSearchTerm("");
		setSearchFilter(null);
		getAllServiceRequests(tableInstance);
	};

	const toggleAll = () => {
		let temp = selectedServiceNameList;
		if (selectedServiceNameList.length != serviceNameList.length) {
			let tempSR = serviceNameList.map((e) => {
				if (!temp.includes(e.code)) {
					temp = temp.concat(e.code);
					e.checked = true;
				}
				return e;
			});
			setSelectedServiceNameList(temp);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		} else {
			let tempSR = serviceNameList.map((e) => {
				e.checked = false;

				return e;
			});
			setSelectedServiceNameList([]);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelection = (e) => {
		let temp = selectedServiceNameList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = true;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = false;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSPMStatus = (e) => {
		let temp = selectedSPMStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSPMStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setSPMStatusList(tempSPMStatus);
			setSelectedSPMStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSPMStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setSPMStatusList(tempSPMStatus);
			setSelectedSPMStatus(temp);
			getAllServiceRequests(tableInstance);
		}
	};
	const togglePaymentStatus = (e) => {
		let temp = selectedPaymentStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			getAllServiceRequests(tableInstance);
		}
	};
	const [numberOfServices, setNumberOfServices] = useState(0);
	const [bulkAssignServiceRequest, setBulkAssignServiceRequest] = useState(
		[]
	);
	useEffect(() => {
		let temp = [];
		selectedServiceRequests.map((e) => {
			if (temp.includes(e.nUserId) === false) {
				temp.push(e.nUserId);
			}
		});
		if (temp.length) {
			api.assignFacilitator({ user_ids: temp, get_request: true }).then(
				(d) => {
					setBulkAssignServiceRequest(d.data);

					let numServices = 0;
					Object.entries(d.data).map(([key, value]) => {
						if (typeof value === "object") {
							numServices += value.length;
							value.map((x) => {
								if (x.refHH !== null) {
									// setSelectedServiceRequestsHasHandholder(true);
								}
							});
						}
					});
					setNumberOfServices(numServices);
				}
			);
		} else {
			// setSelectedServiceRequestsHasHandholder(false);
			setBulkAssignServiceRequest([]);
			setNumberOfServices(0);
		}
	}, [selectedServiceRequests]);
	const [
		showConfirmHandholderAssignmentModal,
		setShowConfirmHandholderAssignmentModal,
	] = useState(false);
	const toggleConfirmHandholderAssignmentModal = () => {
		// if (!selectedHandholder) {
		//   toast("Please select a handholder.", {
		//     autoClose: 5000,
		//     type: toast.TYPE.ERROR,
		//   });
		//   return;
		// }
		if (selectedServiceRequests.length == 0) {
			toast("Please select service requests.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setShowConfirmHandholderAssignmentModal(
			!showConfirmHandholderAssignmentModal
		);
	};

	/*Callbacks for Package filter */
	const toggleAllForPackageFilter = () => 
	{
		let temp =[];
		
		if (selectedPackageNameListForFilter.length != packageNameListForFilter.length && selectedPackageNameListForFilter.length!=(packageNameListForFilter.length+1)) 
		{
			if(selectedPackageNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedPackageNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = packageNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedPackageNameListForFilter(temp);
			setPackageNameListForFilter(tempSR);
			getAllServiceRequests(tableInstance);
		} 
		else
		{
			setSelectedPackageNameListForFilter([]);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelectionForPackageFilter = (e) => {
		setSelectedPackageNameListForFilter(e);
	};
	/* Callbacks for Package filter */

	const onTabChanged = async (selectedTab) => {
        setCurrentActiveTab(selectedTab);
	};

	const getUnreadFeedbackCount = () => {
        try
        {            
            const { data: _ignore_ } = api
                .getUnreadFeedbackCount()
                .then((d) => {
                    if (d.data) 
                    {
                        setunReadFeedbackCount(d.data.unread_feedbacks||0);                      
                    }
                })
                .catch((error) =>
                {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        } 
        catch (error)
        {
        }            
    };

	return (
		currentActiveTab==="Service Requests"?
		(
			<div className={` ${isLoading && "set-opacity"}`}>
				{isLoading && <Spinner className="center-screen" />}

				<Actions
					toggleConfirmHandholderAssignmentModal={
						toggleConfirmHandholderAssignmentModal
					}
					selectedServiceRequestsHasHandholder={
						selectedServiceRequestsHasFacilitator
					}
					assignFacilitators={true}
					numberOfServices={numberOfServices}
					selectedServiceRequests={selectedServiceRequests}
					selectedFacilitator={selectedFacilitator}
					onSelectHandholder={setSelectedFacilitator}
					onAssignHandholder={handleFacilitatorAssigned}
					onUnAssignHandholder={handleFacilitatorUnAssigned}
					facilitatorList={facilitatorList}
					toggleUnassignedServiceRequests={() => {
						if (!tableInstance) return;

						if (showFollowupInPast)
							toggleFollowupInPast(!showFollowupInPast);

						toggleUnassignedServiceRequests(
							!showUnassignedServiceRequests
						);
					}}
					showUnassignedServiceRequests={showUnassignedServiceRequests}
					onSearchInputChange={handleSearchInputChange}
					searchFilter={searchFilter}
					onSearchFilterChange={(option) => {
						setFilterError(false);
						setSearchFilter(option);
					}}
					onSearchClicked={handleSearchClick}
					onClearFilterSearch={handleClearFilterSearch}
					searchTerm={searchTerm}
					filterError={filterError}
					ServiceRequestList={serviceNameList}
					toggleSelection={toggleSelection}
					toggleAll={toggleAll}
					toggleFollowupInPast={() => {
						if (!tableInstance) return;

						if (showUnassignedServiceRequests)
							toggleUnassignedServiceRequests(
								!showUnassignedServiceRequests
							);
						toggleFollowupInPast(!showFollowupInPast);
					}}
					showFollowupInPast={showFollowupInPast}
					toggleToBeFolledUpToday={() => {
						if (!tableInstance) return;
						toggleToBeFolledUpToday(!showToBeFolledUpToday);
					}}
					showToBeFolledUpToday={showToBeFolledUpToday}
					toggleFailedPayments={() => {
						if (!tableInstance) return;
						toggleFailedPayments(!showFailedPayments);
					}}
					showFailedPayments={showFailedPayments}
					serviceRequestStatusList={serviceRequestStatusList}
					toggleStatusSelection={toggleStatusSelection}
					paymentStatusList={paymentStatusList}
					togglePaymentStatus={togglePaymentStatus}
					useForSPM={true}
					SPMStatusList={SPMStatusList}
					toggleSPMStatus={toggleSPMStatus}
					packageNameListForFilter={packageNameListForFilter}
					selectedPackageNameListForFilter={selectedPackageNameListForFilter}
					toggleAllForPackageFilter={toggleAllForPackageFilter}
					toggleSelectionForPackageFilter={toggleSelectionForPackageFilter}
					servicesThroughPackageOptions={servicesThroughPackageOptions}
					selectedServicesThroughPackageOption={selectedServicesThroughPackageOption}
					onServicesThroughPackageOptionChange={(option) => {setSelectedServicesThroughPackageOption(option);}}
					showFeedbackButton={getUser()&&getUser().role.includes(1)}
					unReadFeedbackCount={unReadFeedbackCount}
					onTabChanged={onTabChanged}
					isAssignFacilitatorUploadOpen={isAssignFacilitatorUploadOpen}
					handleAssignFacilitatorUploadClick={handleAssignFacilitatorUploadClick}
					onAssignFacilitatorUpload={onAssignFacilitatorUpload}
					uploadAssignFacilitatorFile={uploadAssignFacilitatorFile}
					FileInputref={FileInputref}
				/>
				<div>
					<ConfirmHandholderAssignmentModal
						useForSPM={true}
						numberOfServices={numberOfServices}
						bulkAssignServiceRequest={bulkAssignServiceRequest}
						isOpen={showConfirmHandholderAssignmentModal}
						toggleModal={toggleConfirmHandholderAssignmentModal}
						selectedServiceRequests={selectedServiceRequests}
						// selectedHandholder={selectedHandholder}
						// handleHandholderAssigned={handleHandholderAssigned}
					/>
				</div>
					<AdminServiceProgressionTable
						data={serviceRequests}
						selectedServiceRequests={selectedServiceRequests}
						onSelectServiceRequest={setSelectedServiceRequests}
						onFetchServiceRequests={fetchServiceRequests}
						pages={pages}
						page={restoreToFirstPage}
						pageSize={pageSize}
					/>
			</div>
		)
		:
		(
			<CustomerFeedbackContainer
				onTabChanged={onTabChanged}
				isForBusinessAdmin={true}
			/>
		)
	);
}
